/* eslint-disable */
import ctype from 'component-type';

const expected = `string`;

/**
 * Check whether or not a given `item` is a String
 * @param {any} item The `item` to check
 * @returns {boolean} Wheter or not the `item` is a indeed a String
 */
const isString = (item) => ctype(item) === expected;

export default isString;
